<template lang="pug">
EditDealTabInnerSection(:full-width="false")
  template(v-slot:header="")
    .online-tab-header
      h2(:class="visible") Program
  template(v-slot:actions)
    BriqButton.add-program-item(small @click="addProgramItem" :class="visible" data-test-id="add-program-item") Add program item
  template(v-slot:body)
    ProgramItems(:program="deal.Program" @addProgramItem="addProgramItem" :shouldShowMultilanguage="shouldShowMultilanguage")
    BriqInput(
      v-model="deal.FakeEstimatedDuration"
      label="Total duration (minutes)"
      help="Notice: This will only appear when program items are present"
      data-test-id="total-duration-minutes"
      )
</template>

<script>
import Vue from 'vue'
import EditDealTabInnerSection from '@/vue/inventory/deals/edit/EditDealTabInnerSection.vue'
import ProgramItems from '@/vue/inventory/deals/edit/tab-online/ProgramItems.vue'
import translationInfoHelperFunctionsMixin from '@v/util/translationInfoHelperFunctionsMixin.js'
import { clone, isEmpty } from 'ramda'

export default {
  name: 'Program',
  components: { EditDealTabInnerSection, ProgramItems },
  mixins: [translationInfoHelperFunctionsMixin],
  props: {
    deal: {
      type: Object,
      required: true,
    },
    shouldShowMultilanguage: Boolean,
    translationInfo: Object,
  },
  computed: {
    visible() {
      return this.shouldShowMultilanguage ? 'hidden' : ''
    },
  },
  methods: {
    addProgramItem() {
      const newItem = {
        duration: 0,
        title: '',
        description: '',
      }
      if (!this.deal.Program) {
        Vue.set(this.deal, 'Program', { 'new-1': [newItem] })
        this.addNewElementTranslationInfoObject({
          translationInfo: this.translationInfo,
          key: '',
          elementToBeAdded: [newItem],
          translationsProperty: 'Program',
        })
      } else {
        const programLength = Object.keys(this.deal.Program).length
        const nextKey = 'new-' + (programLength + 1)
        Vue.set(this.deal.Program, nextKey, [newItem])
        this.addNewElementTranslationInfoObject({
          translationInfo: this.translationInfo,
          key: programLength,
          elementToBeAdded: [newItem],
          translationsProperty: 'Program',
        })
      }
    },
  },
}
</script>

<style scoped lang="stylus"></style>
